import { servicePayments } from "../servicePayments";
import { extendConfigWithXWingspanUserHeader } from "../../shared/utils/extendHeadersWithXWingspanUser";
import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";

export const renewRequirement = async (
  requirementId: string,
  orgPayerId: string | undefined
): Promise<IRequirementResponse> => {
  const response = await servicePayments.post(
    `/requirement/${requirementId}/renew`,
    {},
    extendConfigWithXWingspanUserHeader({}, orgPayerId)
  );
  return response.data;
};
